<script setup>
  import {Input} from 'digitalpower';
  import {onMounted, ref} from "vue";
  import {useUserStore} from "../store/users.js";
  import {useRouter} from "vue-router";
  import {show} from "../services/notification.js";
  const email = ref("");
  const password = ref("");
  const router = useRouter();

  const userStore = useUserStore();

  onMounted(() => {
    document.getElementById("form-container").addEventListener("keypress", (e) => {
      if (e.keyCode === 13) {
        login();
      }
    });
  })

  async function login () {
    let user = await userStore.login(email.value, password.value);
    if(user) {
      show("Sesion iniciada!")
      await router.push("/");
    }
  }
</script>

<template>
<div id="form-container" class="form-container" flex flex-center>
  <form shadow radius-border slide>
    <h1 underline>Iniciar Sesion</h1>
    <Input label="Correo electronico" name="email" autocomplete="email" placeholder="example@example.com" v-model="email"/>
    <Input class="mt-4" label="Tu contraseña" type="text" name="password" autocomplete="password" placeholder="" v-model="password"/>
    <div class="mt-4 buttons" flex flex-center flex-wrap gapped>
      <Input type="button" value="Ingresar" background="var(--primary)" color="white" @click="login"/>
    </div>
  </form>
</div>
</template>

<style scoped lang="scss">
form {
  height: fit-content;
  width: 90%;
  max-width: 600px;

  margin: auto;
  background: white;
  padding: 2em;
}

h1 {
  font-weight: bold;
}

.buttons {
  justify-content: start;
}

.pass {
  display: block;
  margin-top: 1em;
}

.form-container {
  width: 100%;
  height: 100%;
}
</style>